import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Hr from "@saleor/components/Hr";
import Skeleton from "@saleor/components/Skeleton";
import { Timeline, TimelineEvent } from "@saleor/components/Timeline";
import { PageheaderDetails_pageHeader_events } from "@saleor/pageheaders/types/PageheaderDetails";
import React from "react";
import { FormattedMessage, IntlShape, useIntl } from "react-intl";

import { PageHeaderEventsEnum } from "../../../types/globalTypes";

export interface FormData {
  message: string;
}

const getEventMessage = (
  event: PageheaderDetails_pageHeader_events,
  eventLogs: any,
  intl: IntlShape
) => {
  switch (event.action) {
    case PageHeaderEventsEnum.PAGE_HEADER_CREATED:
      return intl.formatMessage(
        {
          defaultMessage: "Pageheader was created by {createdBy}",
          description: "pageheader history message"
        },
        {
          createdBy: event.user ? event.user.email : null
        }
      );
    case PageHeaderEventsEnum.PAGE_HEADER_UPDATED:
      return intl.formatMessage(
        {
          defaultMessage: "Pageheader was updated by {updatedBy}",
          description: "pageheader history message"
        },
        {
          updatedBy: event.user ? event.user.email : null
        }
      );
    case PageHeaderEventsEnum.PAGE_HEADER_DELETED:
      return intl.formatMessage(
        {
          defaultMessage: "Pageheader was deleted by {deletedBy}",
          description: "pageheader history message"
        },
        {
          deletedBy: event.user ? event.user.email : null
        }
      );
    case PageHeaderEventsEnum.PAGE_HEADER_APPLIED:
      return intl.formatMessage(
        {
          defaultMessage: "Applied {appliedCount} custom pages by {appliedBy}",
          description: "pageheader history message"
        },
        {
          appliedCount: eventLogs.count ? eventLogs.count : 0,
          appliedBy: event.user ? event.user.email : null
        }
      );
    case PageHeaderEventsEnum.OTHER:
      return event.action;
  }
};

const useStyles = makeStyles(
  theme => ({
    header: {
      fontWeight: 500,
      marginBottom: theme.spacing(1)
    },
    root: { marginTop: theme.spacing(4) },
    user: {
      marginBottom: theme.spacing(1)
    }
  }),
  { name: "PageheaderHistory" }
);

interface PageheaderHistoryProps {
  history: PageheaderDetails_pageHeader_events[];
}

const PageheaderHistory: React.FC<PageheaderHistoryProps> = props => {
  const { history } = props;
  const classes = useStyles(props);

  const intl = useIntl();

  return (
    <div className={classes.root}>
      <Typography className={classes.header} color="textSecondary">
        <FormattedMessage defaultMessage="History" />
      </Typography>
      <Hr />
      {history ? (
        <Timeline>
          {history
            .slice()
            .reverse()
            .map(event => {
              const eventLogs = JSON.parse(event.logs);
              return (
                <TimelineEvent
                  date={event.created}
                  title={getEventMessage(event, eventLogs, intl)}
                  key={event.id}
                />
              );
            })}
        </Timeline>
      ) : (
        <Skeleton />
      )}
    </div>
  );
};
PageheaderHistory.displayName = "PageheaderHistory";
export default PageheaderHistory;
